const config = () => {
  if (process.env.NODE_ENV === 'production') {
    return {
      serverUrl: process.env.REACT_APP_PROD_SEVER_URL
    };
  }
  return {
    serverUrl: process.env.REACT_APP_DEV_SEVER_URL
  };
};

export default config;



// WEBPACK FOOTER //
// ./src/config.ts